<template>
    <div class="content-index">
        <div class="hero-header" :style="'background-position: right ' + parallaxPosition + 'px'">
            <div class="claim" v-if="windowWidth > 1250">Synchronschauspieler<br />&amp; Musiker</div>
            <AudioDemoPlayer v-if="windowWidth > 1250" />
            <img src="@/assets/img/slant.svg" alt="Slanted Graphic" class="slant" />
        </div>
        <div class="claim" v-if="windowWidth < 1250">Synchronschauspieler<br />&amp; Musiker</div>
        <AudioDemoPlayer v-if="windowWidth < 1250" />

        <NewsItems />

        <Features />

        <WorkRoles />

        <About />

        <FAQs />
    </div>
</template>

<script>
    import VFAPI from '@/modules/module.api.js';

    import AudioDemoPlayer from '@/components/AudioDemoPlayer/AudioDemoPlayer.vue';
    import NewsItems from '@/components/NewsItems/NewsItems.vue';
    import Features from '@/components/Features/Features.vue';
    import WorkRoles from '@/components/WorkRoles/WorkRoles.vue';
    import About from '@/components/About/About.vue';
    import FAQs from '@/components/FAQs/FAQs.vue';

    export default {
        name: 'Index',
        data: function() {
            return {
                windowWidth: window.innerWidth,
                parallaxPosition: 0,
                vfapi: null,
            }
        },
        components: {
            AudioDemoPlayer,
            NewsItems,
            Features,
            WorkRoles,
            About,
            FAQs,
        },
        mounted: function() {
            this.$data.vfapi = new VFAPI();
        },
        created: function() {
            window.addEventListener('resize', this.onResize);
            window.addEventListener('scroll', this.onScroll);
        },
        beforeDestroy() { 
            window.removeEventListener('resize', this.onResize); 
            window.removeEventListener('scroll', this.onScroll); 
        },
        methods: {
            onResize() {
                this.$data.windowWidth = window.innerWidth
            },
            onScroll() {
                this.$data.parallaxPosition = window.scrollY / 4;
            }
        },
    };
</script>

<style scoped lang="less">
    .hero-header {
        background: url('../assets/img/hero-background.jpg');
        background-size: cover;
        width: 100%;
        height: 100vh;
        position: relative;
        z-index: 0;

        & .slant {
            position: absolute;
            bottom: 0px;
            left: 0px;
            right: 0px;
        }
    }

    .claim {
        position: absolute;
        bottom: 475px;
        left: 55px;
        font-size: 56px;
        text-shadow: 0px 6px 24px rgba(0,0,0,0.2);
        line-height: 1;
        font-weight: bold;
        text-align: left;
    }

    @media screen and (max-width: 1250px) {
        .hero-header {
            height: 90vh;
        }

        .claim {
            position: relative;
            text-align: center;
            bottom: inherit;
            left: inherit;
            margin-top: -70px;
            z-index: 100;
        }
    }

    @media screen and (max-width: 600px) {
        .hero-header {
            background-position: -200px 0px !important;
            height: 60vh;
        }
        .claim {
            font-size: 34px;
            transform: translateY(-20px);
        }
    }

    @media screen and (max-width: 360px) {
        .hero-header {
            height: 50vh;
        }
        .claim {
            font-size: 25px;
            transform: translateY(-10px);
        }
    }
</style>